import { render, staticRenderFns } from "./VueBarcodeReader.vue?vue&type=template&id=7cc065bf&"
import script from "./VueBarcodeReader.vue?vue&type=script&lang=ts&"
export * from "./VueBarcodeReader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports